<script lang="ts">
    import { isActive, url, page, redirect } from '@sveltech/routify'
    import AuthService from '../../helpers/AuthService'
    import { Jellyfish } from 'svelte-loading-spinners'
    import AppContainer from '../../components/AppContainer.svelte'

    let profileImage = ''
    let menuState = false
    let authenticated = authenticateUser()
    const LINKS = [
        ['.', 'Home/Sources'],
        ['./chat-config', 'Chat Settings'],
        ['./hypetrain-settings', 'Hypetrain Settings'],
    ]

    async function authenticateUser() {
        const res = await AuthService.reAuthFromToken()

        if (!res.user) {
            return $redirect('/')
        }

        profileImage = res.user.profileImage
        return true
    }

    async function logUserOut() {
        const res = await AuthService.logout()
        const tokenExists = await AuthService.getToken()

        if (!tokenExists) {
            return $redirect('/')
        }
        return res
    }

    function handleClick() {
        menuState = menuState ? false : true
    }
</script>

{#await authenticated}
    <div
        class="h-screen w-screen absolute top-0 left-0 flex items-center justify-center">
        <Jellyfish size="100" />
    </div>
{:then}
    <AppContainer {profileImage}>
        <div class="max-w-6xl mx-auto">
            <slot />
        </div>
    </AppContainer>
{:catch}
    {$redirect('/')}
{/await}

<style>
    main {
        padding: 1rem;
    }
</style>
